<template>
  <div class="p-y-6">
    <div class="p-6 text-center bg-gray20 m-b-6">
      <div class="h3 c-gray80 m-b-2">
        <template>
          <!-- eslint-disable-next-line max-len -->
          Help your <span class="text-capitalize">{{ storeCity | lowercase }}</span> store by recruiting Pros to meet local customer demand.
        </template>
      </div>
      <div class="text-lg c-gray70">
        <template>
          <!-- eslint-disable-next-line max-len -->
          Sign up more Pros so we can ensure Home Depot customers can connect with local Pros for their home services needs.
        </template>
      </div>
    </div>

    <div v-if="reports.length" class="p-x-6">
      <div class="text-sm c-gray70">
        Last Updated {{ lastUpdated }}
      </div>

      <div class="text-center text-bold c-gray80 m-b-2 p-x-3">
        <div class="layout">
          <div class="layout-item is-2 offset-4">
            <div class="text-md m-b-1">
              Available Pros
            </div>
            <div class="h5">
              {{ prosCurrent }}
            </div>
          </div>
          <div class="layout-item is-2">
            <div class="text-md m-b-1">
              Pros Needed
            </div>
            <div :class="prosNeeded > 0 ? 'c-red' : 'c-green'" class="h5" >
              {{ prosNeeded }}
            </div>
          </div>
        </div>
      </div>
      <stock-report-item v-for="(report, i) in reports" :key="i" v-bind="report" class="bd-t-gray40"/>
    </div>
  </div>
</template>

<script>
import StockReportItem from './components/StockReportItem';

export default {
  name: 'stock-report',
  components: {
    StockReportItem,
  },
  props: {
    reports: {
      type: Array,
      default: () => ([]),
    },
    prosNeeded: {
      type: Number,
      default: 0,
    },
    prosCurrent: {
      type: Number,
      default: 0,
    },
    lastUpdated: {
      type: String,
      default: '',
    },
    storeCity: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
